// Stacked progress bar showing done / in-progress / not-started ratios.
// Used by initiative and release cards.
export interface ProgressStackProps {
  done: number;
  inProgress: number;
  notStarted: number;
  height?: number;
}

export function ProgressStack({
  done,
  inProgress,
  notStarted,
  height = 8,
}: ProgressStackProps) {
  const total = Math.max(0, done + inProgress + notStarted);
  if (total === 0) {
    return (
      <div
        style={{
          height,
          background: 'var(--apm-bg-sunken)',
          borderRadius: 999,
        }}
      />
    );
  }
  const pct = (n: number) => `${(n / total) * 100}%`;
  return (
    <div
      style={{
        display: 'flex',
        height,
        borderRadius: 999,
        background: 'var(--apm-bg-sunken)',
        overflow: 'hidden',
      }}
    >
      <div style={{ width: pct(done), background: 'var(--apm-ok)' }} />
      <div style={{ width: pct(inProgress), background: 'var(--apm-warn)' }} />
      <div style={{ width: pct(notStarted), background: 'transparent' }} />
    </div>
  );
}
